import { defineComponent } from "vue";

export default defineComponent({
  template: `
      <div class="tariff-category-picker">
      <button
          class="nav-btn"
          @click="setIsClient(true)"
          :class="this.isClient ? 'active' : ''"
      >
        Mám služby od PODY
      </button>
      <button
          class="nav-btn"
          @click="setIsClient(false)"
          :class="!this.isClient ? 'active' : ''"
      >
        Nemám služby od PODY
      </button>
      </div>
    `,
  name: "TariffCategoryPicker",
  emits: ["isClientChange"],
  props: ["isClient"],
  methods: {
    async setIsClient(isClient: boolean) {
      this.$emit("isClientChange", isClient);
    },
  },
});
